import { Injectable } from '@angular/core'
import { DialogService } from 'primeng/dynamicdialog'
import { ToastAlertComponent } from '../../03_shared-components/01_alerts/toast-alert/toast-alert.component'
import { ExecuteDeleteAPI, ExecuteGetAPI, ExecutePostAPI, ExecutePutAPI } from './execute_api-calls'
import { type ApiMessagesInterface } from '../interfaces/data-expected-from-backend/api-data-interface'
import { BehaviorSubject } from 'rxjs'

@Injectable()
export class RecoBuyQtyAPIs {
  recoPlans: any[] = []

  constructor (public dialogService: DialogService, public toastAlert: ToastAlertComponent) {}

  async GetAllPlans () {
    const path = '/get_plans'
    const messages = {
      success: '---> API Call Successful: Get All Plans',
      error: 'Error retrieving plans'
    }

    return await ExecuteGetAPI(path, this, messages)
  }

  private readonly RecoPlans = new BehaviorSubject<any[]>(null)
  public RecoPlans$ = this.RecoPlans.asObservable()

  onSetRecoPlans (plans: any[]) {
    return this.RecoPlans.next(plans)
  }

  getRecoPlans () {
    return this.RecoPlans.asObservable()
  }

  async GetAllSeasons () {
    const path = '/get_seasons'
    const messages = {
      success: '---> API Call Successful: Get Seasons',
      error: 'Error retrieving buying seasons'
    }

    return await ExecuteGetAPI(path, this, messages)
  }

  private readonly Seasons = new BehaviorSubject<any[]>(null)
  public Seasons$ = this.Seasons.asObservable()

  onSetSeasons (seasons: string[]) {
    return this.Seasons.next(seasons)
  }

  getSeasons () {
    return this.Seasons.asObservable()
  }

  async GetPlan (planName: string) {
    const path = '/reco/grid'
    const messages = {
      success: '---> API Call Successful: Get Plan ' + planName,
      error: 'Error retrieving plan ' + planName
    }

    return await ExecutePostAPI(path, this, { plan_name: planName }, messages)
  }

  async DeletePlan (planName: string) {
    const path = '/delete_plan'
    const messages = {
      success: 'Successfully deleted plan ' + planName,
      error: 'Error deleting plan ' + planName,
      showSuccessToast: true
    }
    return await ExecuteDeleteAPI(path + '/' + planName, this, messages)
  }

  async DeletePlanLines (planName: string, rowId: number) {
    const path = '/delete_plan'
    const messages = {
      success: 'Successfully deleted plan ' + planName + ' row id ' + rowId,
      error: 'Error deleting plan ' + planName + ' row id ' + rowId,
      showSuccessToast: true
    }
    return await ExecuteDeleteAPI(path + '/' + planName + '/' + rowId, this, messages)
  }

  async UploadPlan (planData) {
    const path = '/upload_plan'
    const messages = {
      success: 'Successfully uploaded plan ' + planData.plan_name,
      error: 'Error uploading plan ' + planData.plan_name,
      showSuccessToast: true
    }
    // TODO will return id? match to row?
    return await ExecutePostAPI(path, this, planData, messages)
  }

  async SavePlan (planData) {
    const path = '/save_plan'
    const messages = {
      success: 'Successfully saved plan ' + planData.plan_name,
      error: 'Error saving plan ' + planData.plan_name,
      showSuccessToast: true
    }
    // TODO will return id? match to row?
    return await ExecutePutAPI(path, this, planData, messages)
  }

  async ApproveRows (planData) {
    const path = '/approve_rows'
    const messages = {
      success: 'Successfully approved plan rows',
      error: 'Error approving rows ' + planData.plan_name,
      showSuccessToast: true
    }
    return await ExecutePostAPI(path, this, planData, messages)
  }

  async RejectRows (planData) {
    const path = '/reject_rows'
    const messages = {
      success: 'Successfully rejected plan rows',
      error: 'Error rejecting rows ' + planData.plan_name,
      showSuccessToast: true
    }
    return await ExecutePostAPI(path, this, planData, messages)
  }

  async changeRowLock (planData) {
    const path = '/update_lock'
    const messages = {
      success: 'Successfully changed row lock',
      error: 'Error changing row lock ' + planData.plan_name,
      showSuccessToast: true
    }
    return await ExecutePostAPI(path, this, planData, messages)
  }

  async SubmitRows (planData) {
    const path = '/submit_plan'
    const messages = {
      success: 'Successfully submtited plan rows',
      error: 'Error submitting plan rows',
      showSuccessToast: true
    }
    return await ExecutePostAPI(path, this, planData, messages)
  }

  async RunBuyReco (planName: string) {
    const path = '/run_plan'
    const messages = {
      success: 'Successfully ran plan ' + planName,
      error: 'Error running plan ' + planName,
      showSuccessToast: true
    }
    return await ExecutePostAPI(path, this, { plan_name: planName }, messages)
  }
}
